<template>
  <section>
    <div class="hero-wrap">
      <div class="hero-mask opacity-8 bg-dark"></div>
      <div class="hero-bg parallax"
           :style="`background-image: url('../images/intro-bg-2.jpg'); background-size: cover; background-repeat: no-repeat; background-attachment: fixed; background-position: center 1780.38px;`"></div>
      <div class="hero-content section">
        <div class="container text-center py-5 wow fadeInUp" style="visibility: visible; animation-name: none;">
          <h2 class="text-10 fw-600 text-white mb-5">Interested in working with me?</h2>
          <a href="https://api.whatsapp.com/send?phone=2348104031837&text=Hey%20Theodore%2C%20I%20have%20a%20Job%20for%20you.%20" target="blank" class="btn btn-primary rounded-0 " 
             style="visibility: visible; animation-delay: 1s; animation-name: none;">Hire Me!</a></div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'hero-component'
}
</script>